module.exports = __webpack_public_path__ + "static/img/eyebrows_08.fb15d7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyebrows/thumbnail/eyebrows_08.png
// module id = Lbob
// module chunks = 0